<div class="spinner">
  <mat-spinner disableClose="true" data="Cargando..." diameter="35" strokeWidth="2"></mat-spinner>
</div>

